import React, { createContext } from 'react';
import { Outlet } from 'react-router';
import { TimeBasedWaitingDialog } from './TimeBasedWaitingDialog';
import { BlobDetailsContextValue } from './types';
import { useBlobDetailsActions } from './useBlobDetailsActions';
import { useBlobDetailsMutations } from './useBlobDetailsMutations';
import { useCurrentMymeData } from './useCurrentMymeData';

export const Context = createContext<BlobDetailsContextValue>({
  modules: [],
  currentBlob: null,
  mode: 'content',
  mymeName: '',
  currentModuleId: '',
  isParticipationFetching: false,
  startMyme: () => {},
  goToNextBlob: () => {},
  getMymeId: () => {},
  getIsStartedByUser: () => {},
  getMymeName: () => {},
  openTimeBasedWaitingDialog: () => {},
  updateNonInteractiveBlobProgressMutation: async () => undefined,
  updateOpenQuizBlobProgressMutation: async () => undefined,
  updateSelectQuizBlobProgressMutation: async () => undefined
});

export const BlobDetailsProvider = () => {
  const {
    mymeId,
    mymeName,
    currentModuleId,
    setCurrentModuleId,
    currentBlob,
    setCurrentBlob,
    mode,
    setMode,
    getMymeId,
    getIsStartedByUser,
    getMymeName,
    blob,
    mymeModules,
    isParticipationFetching
  } = useCurrentMymeData();

  const { timeBasedWaitingDialog, openTimeBasedWaitingDialog, handleGoBackToMymeDialog, startMyme, goToNextBlob } =
    useBlobDetailsActions(mymeId, setCurrentBlob, setCurrentModuleId, setMode, currentBlob, mymeModules);

  const {
    updateNonInteractiveBlobProgressMutation,
    updateOpenQuizBlobProgressMutation,
    updateSelectQuizBlobProgressMutation
  } = useBlobDetailsMutations(
    currentBlob,
    mymeId,
    blob,
    currentBlob?.progress?.isFinished,
    currentModuleId,
    goToNextBlob
  );

  return (
    <Context.Provider
      value={{
        currentBlob,
        mode,
        mymeModules,
        mymeId,
        currentModuleId,
        mymeName,
        isParticipationFetching,
        startMyme,
        goToNextBlob,
        updateNonInteractiveBlobProgressMutation,
        getMymeId,
        getIsStartedByUser,
        getMymeName,
        openTimeBasedWaitingDialog,
        updateOpenQuizBlobProgressMutation,
        updateSelectQuizBlobProgressMutation
      }}
    >
      <Outlet />
      {timeBasedWaitingDialog.isOpen && currentBlob && (
        <TimeBasedWaitingDialog
          currentTimeToUnlock={currentBlob.currentTimeToUnlock}
          onClose={handleGoBackToMymeDialog}
        />
      )}
    </Context.Provider>
  );
};
